import { combineReducers, createStore } from 'redux';
import { sessionReducer, sessionService } from 'redux-react-session';

/**
 * session 初始設定
 * //https://bernabe9.github.io/redux-react-session/
 * */
const SessionInitialization = {

    init: function () {

        const reducers = {
            session: sessionReducer
        };
        const reducer = combineReducers(reducers);
        const store = createStore(reducer);

        const validateSession = (session) => {
            // check if your session is still valid with a server check, through axios for instance
            return true;
        }
        var sessionKey = "SmmDB_Session";
        const options = { refreshOnCheckAuth: true, redirectPath: '/manager/index', driver: 'COOKIES', expires:1, validateSession, sessionKey: sessionKey, sessionData: sessionKey };
      
        sessionService.initSessionService(store, options)
            .then(() => {
                console.log('Redux React Session is ready and a session was refreshed from your storage');
              
            })
            .catch(() => {
                console.log('Redux React Session is ready and there is no session in your storage')
            });

    }
}
export default SessionInitialization;
